import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "s20_mobile px-4" }
const _hoisted_2 = {
  key: 0,
  class: "s20 widget flex align-items-center px-1 py-5 my-5"
}
const _hoisted_3 = { class: "s2_mobile h-100p px-7" }
const _hoisted_4 = { class: "rounded-100 overflow-hidden item active" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "s3_mobile h-100p px-2" }
const _hoisted_7 = { class: "mb-2" }
const _hoisted_8 = { class: "s4_mobile h-100p px-3" }
const _hoisted_9 = { class: "font-normal" }
const _hoisted_10 = { class: "text-2xl" }
const _hoisted_11 = { class: "widget px-7 py-7 my-5" }
const _hoisted_12 = { class: "s20 items-center gap-6 px-5 pb-6 collapse-content active" }
const _hoisted_13 = { class: "s20 px-4" }
const _hoisted_14 = { class: "form-field-floating lg reactive my-4" }
const _hoisted_15 = { class: "grid6 grid-row-gap-0 px-4 my-1" }
const _hoisted_16 = ["id", "onUpdate:modelValue"]
const _hoisted_17 = ["for"]
const _hoisted_18 = { class: "s20 items-center gap-6 px-5 pb-6 collapse-content active" }
const _hoisted_19 = { class: "s20 px-4" }
const _hoisted_20 = { class: "form-field-floating lg reactive my-4" }
const _hoisted_21 = ["value"]
const _hoisted_22 = {
  key: 0,
  class: "text-red"
}
const _hoisted_23 = { class: "s20 px-4" }
const _hoisted_24 = { class: "form-field-floating lg reactive my-4" }
const _hoisted_25 = ["value"]
const _hoisted_26 = {
  key: 0,
  class: "text-red"
}
const _hoisted_27 = { class: "s20 px-4" }
const _hoisted_28 = { class: "form-field-floating lg reactive my-4" }
const _hoisted_29 = {
  key: 0,
  class: "text-red"
}
const _hoisted_30 = { class: "s20 px-4" }
const _hoisted_31 = { class: "custom-upload-st2" }
const _hoisted_32 = { class: "s12" }
const _hoisted_33 = {
  id: "file-upload-title",
  class: "custom-upload-text"
}
const _hoisted_34 = {
  id: "file-upload-title",
  class: "custom-upload-text"
}
const _hoisted_35 = {
  key: 0,
  class: "text-red"
}
const _hoisted_36 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_37 = { key: 0 }

import { inject, reactive } from "vue";
    import FinancePrelevementsForm from "@/views/finance/@forms/FinancePrelevementsForm.vue";
    import { ref } from 'vue';
    import CustomStepper from "@/components/CustomStepper.vue";
    import CustomStepperStep from "@/components/CustomStepperStep.vue";
    import { AMOUNT_FORMAT_CONFIG, formatDateFrench, MONTHS_FR } from "@/utils";
    import axios from "axios";
    import { useToastStore } from "@/stores/toast.store";
    import moment from "moment";
import { useConfirmationStore } from "@/stores/confirmation.store";

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CollectivitesManagementValidationModal',
  setup(__props, { expose: __expose }) {

    // @ts-expect-error raison: lib externe mal typée
    const toastStore = useToastStore();
    const confirmationStore = useConfirmationStore();
    const BACKEND_URL = inject('BACKEND_URL');
    const isOpened = ref(false);
    const loading = ref(false);
    const collectivite = ref(null as any);
    const customStepperRef = ref<InstanceType<typeof CustomStepper> | null>(null);
    let promise: Promise<boolean>;
    let resolvePromise: any;
    let rejectPromise: any;
    const startupInfos = ref({
        collectivite: null,
        periodes: []
    });

    const formData = reactive({
        taux_interet: 0,
        indexes: [],
        periode: '',
        periode_label: '',
        montant_expected: 0,
        montant_prelevement: 0,
        file: null as File | null,
        file_name: '',
        file_preview: null as any,
    });
    const errors = reactive({
        periode: "",
        montant_expected: "",
        montant_prelevement: "",
        file: "",
    });

    async function open(id: number) {
        await fetchStartupInfos(id);
        promise = new Promise((resolve, reject) => {
            resolvePromise = resolve;
            rejectPromise = reject;
        });
        isOpened.value = true;
        return await promise;
    }

    async function fetchStartupInfos(id: number) {
        loading.value = true;
        try {
            const response = await axios.get(`/backoffice/collectivites/${id}/get_startupinfos_validation`);
            collectivite.value = response.data.collectivite;
            const periode = moment(response.data.periode);
            if (periode.isValid()) {
                formData.periode = periode.format('YYYY-MM-DD');
                formData.periode_label = MONTHS_FR[periode.month()] + ' ' + periode.year()
            }
            formData.montant_expected = response.data.montant_prelevement_expected;
            Object.assign(formData, {
                taux_interet: response.data.profil.taux_interet,
                indexes: response.data.profil.index && response.data.profil.index.length > 0 ? response.data.profil.index : Array.from({ length: 12 }, (_, index) => 0)
            });
        } catch(error: any) {
            toastStore.error(error.message || 'Une erreur est survenue lors de la requête au serveur.');
        } finally {
            loading.value = false;
        }
    }

    function onClose() {
        resolvePromise(false);
    }

    function onFileUploaded(event: any) {
        if (event.target.files.length > 0) {
            var reader = new FileReader();
            reader.onload = function(e) {
                formData.file = event.target.files[0];
                formData.file_name = event.target.files[0].name;
                formData.file_preview = e.target!.result as string;
                event.target.value = null;
            }
            reader.readAsDataURL(event.target.files[0]);
        }
    }

    function validate() {
        let isValid = true;
        errors.periode = '';
        if (!formData.periode) {
            errors.periode = "La période est requise";
            isValid = false;
        }

        /*errors.montant_expected = '';
        if (!formData.montant_expected || formData.montant_expected <= 0) {
            errors.montant_expected = "Le montant à récupérer est invalide";
            isValid = false;
        }

        errors.montant_prelevement = '';
        if (!formData.montant_prelevement || formData.montant_prelevement <= 0 || formData.montant_prelevement < formData.montant_expected) {
            errors.montant_prelevement = "Le montant du prélèvement est invalide";
            isValid = false;
        }*/

        errors.file = '';
        if (!formData.file) {
            errors.file = "Le fichier de prélèvement est requis";
            isValid = false;
        }

        return isValid;
    }

    async function submit() {
        const stepperEl = customStepperRef.value;
        if (!stepperEl) { return; }

        if (stepperEl.activeIndex == 0) { stepperEl.next(); }
        else {
            if (!validate()) { return; }

            const confirm = await confirmationStore.open('Vérouillage collectivité', 'Voulez-vous vraiment proceder au verouillage de cette collectivité ? Cette action est irreversible');
            if (!confirm) { return; }

            loading.value = true;
            try {
                const formToUpload = new FormData();
                formToUpload.append("collectivite_id", collectivite.value.id.toString());
                formToUpload.append("taux_interet", formData.taux_interet.toString());
                formToUpload.append("indexes", JSON.stringify(formData.indexes));
                formToUpload.append("periode_prelevement", formData.periode);
                formToUpload.append("montant_prelevement", formData.montant_prelevement.toString());
                formToUpload.append("fichier_prelevement", formData.file!, formData.file!.name);
                await axios.post(`/backoffice/collectivites/${collectivite.value.id}/validate_collectivite`, formToUpload);
                toastStore.success('La collectivité a été verouillée');
                resolvePromise(true);
                isOpened.value = false;
            } catch(error: any) {
                toastStore.error(error.message || 'Une erreur est survenue lors de la requête au serveur.');
            } finally {
                loading.value = false;
            }
        }
        
    }

    function previous() {
        const stepperEl = customStepperRef.value;
        if (!stepperEl) { return; }

        stepperEl.previous();
    }

    __expose({ open, close });

return (_ctx: any,_cache: any) => {
  const _component_money3 = _resolveComponent("money3")!
  const _component_custom_button = _resolveComponent("custom-button")!
  const _component_custom_modal = _resolveComponent("custom-modal")!

  return (_openBlock(), _createBlock(_component_custom_modal, {
    show: isOpened.value,
    "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((isOpened).value = $event)),
    onClosed: onClose,
    classesNames: 'modal-fullscreen'
  }, {
    header: _withCtx(() => [...(_cache[4] || (_cache[4] = [
      _createElementVNode("h4", { class: "font-semibold text-primary-color" }, "Validation du dossier de collectivité", -1)
    ]))]),
    footer: _withCtx(() => [...(_cache[31] || (_cache[31] = [
      _createTextVNode(" ", -1)
    ]))]),
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("section", _hoisted_1, [
          (collectivite.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("img", {
                      src: collectivite.value.logo ? (_unref(BACKEND_URL) + '/assets/collectivites/' + collectivite.value.logo) : '/assets/logos/logo2.svg',
                      width: "100%"
                    }, null, 8, _hoisted_5)
                  ])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("h4", _hoisted_7, _toDisplayString(collectivite.value.nom || ''), 1),
                  _createElementVNode("h3", null, _toDisplayString(collectivite.value.rccm || 'N/A'), 1)
                ]),
                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "s3_mobile h-100p px-2" }, [
                  _createElementVNode("h4", { class: "font-normal mb-5" }, _toDisplayString('0 / 0 Membres')),
                  _createElementVNode("span", { class: "tag-state warning stroke" }, "En cours"),
                  _createElementVNode("span", { class: "tag-state notif stroke" }, "Actif")
                ], -1)),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("h4", _hoisted_9, [
                    _cache[5] || (_cache[5] = _createTextVNode(" Date de création ", -1)),
                    _cache[6] || (_cache[6] = _createElementVNode("br", { class: "mb-2" }, null, -1)),
                    _createElementVNode("b", _hoisted_10, _toDisplayString(_unref(formatDateFrench)(collectivite.value.created_at)), 1)
                  ])
                ]),
                _cache[8] || (_cache[8] = _createElementVNode("div", { class: "s8_mobile h-100p px-5" }, [
                  _createElementVNode("div", {
                    class: "h-60 rounded-100 position-relative",
                    style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
                  }, [
                    _createElementVNode("div", { class: "widget-floating py-0 text-xl flex-right" }, "Membres " + _toDisplayString('0') + "%"),
                    _createElementVNode("div", {
                      class: "h-100p flex align-items-center justify-content-left rounded-100 text-2xl px-5 bg-pop-green",
                      style: { width: '0%' }
                    }, " 0 / 0 ")
                  ])
                ], -1))
              ]))
            : _createCommentVNode("", true),
          _cache[30] || (_cache[30] = _createElementVNode("div", { class: "clear-both" }, null, -1)),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(CustomStepper, {
              ref_key: "customStepperRef",
              ref: customStepperRef
            }, {
              default: _withCtx(() => [
                _createVNode(CustomStepperStep, { title: "Vérification du profil financier" }, {
                  default: _withCtx(() => [
                    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "s10_mobile container-full-2" }, [
                      _createElementVNode("h2", { class: "flex align-items-center gap-4 font-medium text-primary-color my-5" }, [
                        _createElementVNode("img", {
                          src: "/public/icons/icon-info-perso.svg",
                          class: "size-l",
                          alt: ""
                        }),
                        _createTextVNode(" Profil Financier ")
                      ])
                    ], -1)),
                    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_money3, _mergeProps({
                            class: "form-input",
                            modelValue: formData.taux_interet,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.taux_interet) = $event)),
                            name: "profil.taux_interet",
                            id: "profil.taux_interet",
                            placeholder: ""
                          }, _unref(AMOUNT_FORMAT_CONFIG)), null, 16, ["modelValue"]),
                          _cache[9] || (_cache[9] = _createElementVNode("label", { for: "taux_interet" }, [
                            _createTextVNode("Taux Interets Microfinance "),
                            _createElementVNode("b", { class: "color-danger" }, "*")
                          ], -1))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formData.indexes, (indexEl, i) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "form-field-floating lg reactive my-4",
                            key: 'index_' + (i + 1)
                          }, [
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              class: "form-input",
                              name: "index[]",
                              id: 'index_' + (i + 1),
                              placeholder: "",
                              "onUpdate:modelValue": ($event: any) => ((formData.indexes[i]) = $event)
                            }, null, 8, _hoisted_16), [
                              [_vModelText, formData.indexes[i]]
                            ]),
                            _createElementVNode("label", {
                              for: 'index_' + (i + 1)
                            }, [
                              _createTextVNode("Index " + _toDisplayString(i + 1) + " ", 1),
                              _cache[10] || (_cache[10] = _createElementVNode("b", { class: "color-danger" }, "*", -1))
                            ], 8, _hoisted_17)
                          ]))
                        }), 128))
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(CustomStepperStep, { title: "Effectuer le 1er prélèvement" }, {
                  default: _withCtx(() => [
                    _cache[22] || (_cache[22] = _createElementVNode("div", { class: "s10_mobile container-full-2" }, [
                      _createElementVNode("h2", { class: "flex align-items-center gap-4 font-medium text-primary-color my-5" }, [
                        _createElementVNode("img", {
                          src: "/public/icons/icon-info-perso.svg",
                          class: "size-l",
                          alt: ""
                        }),
                        _createTextVNode(" Enregistrer le prélèvement ")
                      ])
                    ], -1)),
                    _cache[23] || (_cache[23] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("input", {
                            type: "text",
                            class: "form-input",
                            name: "periode_prelevement",
                            id: "periode_prelevement",
                            placeholder: "",
                            value: formData.periode_label,
                            readonly: true
                          }, null, 8, _hoisted_21),
                          _cache[13] || (_cache[13] = _createElementVNode("label", { for: "periode_prelevement" }, [
                            _createTextVNode("Période "),
                            _createElementVNode("b", { class: "color-danger" }, "*")
                          ], -1))
                        ]),
                        (!!errors['periode'])
                          ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(errors['periode']), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("input", {
                            type: "number",
                            class: "form-input",
                            name: "montant_decaissement_expected",
                            id: "montant_decaissement_expected",
                            placeholder: "",
                            value: formData.montant_expected,
                            readonly: true
                          }, null, 8, _hoisted_25),
                          _cache[14] || (_cache[14] = _createElementVNode("label", { for: "montant_decaissement_expected" }, [
                            _createTextVNode("Montant à recevoir "),
                            _createElementVNode("b", { class: "color-danger" }, "*")
                          ], -1))
                        ]),
                        (!!errors['montant_expected'])
                          ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(errors['montant_expected']), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            class: "form-input",
                            name: "montant_decaissement_expected",
                            id: "montant_decaissement_expected",
                            placeholder: "",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.montant_prelevement) = $event))
                          }, null, 512), [
                            [_vModelText, formData.montant_prelevement]
                          ]),
                          _cache[15] || (_cache[15] = _createElementVNode("label", { for: "montant_decaissement_expected" }, [
                            _createTextVNode("Montant du virement "),
                            _createElementVNode("b", { class: "color-danger" }, "*")
                          ], -1))
                        ]),
                        (!!errors['montant_prelevement'])
                          ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(errors['montant_prelevement']), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_30, [
                        _cache[21] || (_cache[21] = _createElementVNode("label", { for: "" }, [
                          _createTextVNode("Fichier de virement "),
                          _createElementVNode("b", { class: "color-danger" }, "*")
                        ], -1)),
                        _createElementVNode("label", {
                          for: "file-prelevement",
                          class: _normalizeClass(["mt-4 custom-upload", {'active': formData.file}])
                        }, [
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("input", {
                              id: "file-prelevement",
                              class: "display-none",
                              type: "file",
                              onChange: _cache[2] || (_cache[2] = ($event: any) => (onFileUploaded($event))),
                              accept: ".pdf"
                            }, null, 32),
                            _cache[19] || (_cache[19] = _createElementVNode("div", { class: "s4 custom-upload-img" }, ".PDF", -1)),
                            _createElementVNode("div", _hoisted_32, [
                              _createElementVNode("span", _hoisted_33, _toDisplayString(formData.file_name ? formData.file_name : 'Charger le fichier'), 1),
                              _cache[16] || (_cache[16] = _createTextVNode()),
                              _cache[17] || (_cache[17] = _createElementVNode("b", { class: "color-danger" }, "*", -1)),
                              _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1)),
                              _createElementVNode("span", _hoisted_34, _toDisplayString(formData.file_name ? 'Doc chargé' : 'Uploader le doc'), 1)
                            ]),
                            _cache[20] || (_cache[20] = _createElementVNode("div", { class: "s4 right" }, [
                              _createElementVNode("img", {
                                src: "/icons/icon-upload.svg",
                                class: "custom-upload-icon"
                              })
                            ], -1))
                          ])
                        ], 2),
                        (!!errors['file'])
                          ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(errors['file']), 1))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 512),
            _cache[28] || (_cache[28] = _createElementVNode("div", { class: "clear-both" }, null, -1)),
            _createElementVNode("div", _hoisted_36, [
              (customStepperRef.value && customStepperRef.value.activeIndex > 0)
                ? (_openBlock(), _createBlock(_component_custom_button, {
                    key: 0,
                    classesList: 'btn-ultra lg shadow-0',
                    onClick: previous
                  }, {
                    default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                      _createElementVNode("span", null, "Précédent", -1)
                    ]))]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _cache[27] || (_cache[27] = _createElementVNode("div", { style: {"flex":"1"} }, " ", -1)),
              _createVNode(_component_custom_button, {
                classesList: 'btn-ultra lg shadow-0',
                onClick: submit,
                loading: loading.value
              }, {
                default: _withCtx(() => [
                  (customStepperRef.value && customStepperRef.value.activeIndex == 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_37, "Suivant"))
                    : _createCommentVNode("", true),
                  (customStepperRef.value && customStepperRef.value.activeIndex == 1)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _cache[25] || (_cache[25] = _createElementVNode("img", {
                          src: "/icons/icon-valider.svg",
                          class: "btn-icon",
                          alt: ""
                        }, null, -1)),
                        _cache[26] || (_cache[26] = _createElementVNode("span", null, "Valider", -1))
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["loading"])
            ]),
            _cache[29] || (_cache[29] = _createElementVNode("div", { class: "clear-both" }, null, -1))
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})